import React, { PureComponent } from "react";

import {
  TTP_BLOG_URL,
  TTP_FFF_BLOG,
  TTP_DEG_BLOG,
  TTP_BE_ACCOUNTANTS_BLOG,
  TTP_ACCOUNTING_URL,
  TTP_POWERTEAM_URL,
  TTP_EVENT_URL
} from "Config";
import Drawer from "../Drawer";
import styles from "./DrawersList.local.scss";
import classnames from "classnames";
import { slugify } from "Utils";

import _ from "i18n";
import { TTP_FORUM_URL, TTP_MEDIA_URL } from "../../../../config";

export default class DrawersListComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: "drawer-0"
    };
  }

  renderDrawer(item, index, small) {
    const { community, lng } = this.props;
    const { openDrawer } = this.state;

    let icon = "icon-grid";
    let url = "";

    switch (item.type) {
      case "BLOG":
        icon = "icon-book-open";
        switch (parseInt(community.id, 10)) {
          case 4:
            url = TTP_DEG_BLOG;
            break;
          case 8:
            url = TTP_BE_ACCOUNTANTS_BLOG;
            break;
          case 9:
            url = TTP_FFF_BLOG;
            break;
          default:
            url = `${TTP_BLOG_URL}/${lng}/community/${
              community.url ? community.url : slugify(community.name)
            }/${community.id}`;
        }
        break;
      case "EVENT":
        icon = "icon-calendar";
        url = TTP_EVENT_URL;
        break;
      case "FORUM":
        icon = "icon-speech";
        url = `${TTP_FORUM_URL}/community/${
          community.url ? community.url : slugify(community.name)
        }/${community.id}`;
        break;
      case "MEDIA":
        icon = "icon-picture";
        url = `${TTP_MEDIA_URL}/community/${
          community.url ? community.url : slugify(community.name)
        }/${community.id}`;
        break;
      default:
        url = item.url || "";
    }
    return (
      <li key={`drawer-${index}`}>
        <Drawer
          icon={
            item.icon ? (
              <img src={item.icon} alt="" />
            ) : (
              <i className={`icon ${icon}`} />
            )
          }
          label={item.label || _(item.type)}
          src={url}
          isActive={`drawer-${index}` === openDrawer}
          appType={item.app}
          isSmall={small}
        />
      </li>
    );
  }

  renderDrawers() {
    const { drawers, isOpen } = this.props;

    let exists = [];
    return (
      <ul
        className={classnames(
          styles.drawers,
          isOpen ? styles.iframeOpened : null
        )}
      >
        {drawers.map((item, index) => {
          // let url = "";
          if (
            ["BLOG", "EVENT", "FORUM", "MEDIA"].indexOf(item.type) !== -1 &&
            exists.indexOf(item.type) !== -1
          ) {
            return null;
          }
          //if (index < 4) {
          exists.push(item.type);
          return this.renderDrawer(item, index, false);
          // } else {
          //   return null;
          // }
        })}
        {/*drawers.length > 4 && (
          <li key={`drawer-plus`} className={styles.drawer_plus}>
            <span className={styles.drawer_plus_icon}>
              +
              <ul className={styles.drawer_plus_apps}>
                {drawers.map((item, index) => {
                  if (index < 4) {
                    return null;
                  }
                  return this.renderDrawer(item, index, true);
                })}
              </ul>
            </span>
          </li>
              )*/}
      </ul>
    );
  }

  renderApps() {
    const { apps, isOpen } = this.props;
    const { openDrawer } = this.state;

    return (
      <ul
        className={classnames(
          styles.drawers_apps,
          isOpen ? styles.iframeOpened : null
        )}
      >
        {apps.map((item, index) => {
          let icon = "icon-grid";
          let url = "";
          switch (item) {
            case "DASHBOARD":
              icon = `https://s3.tamtam.pro/v2/apps/accounting.png`;
              url = `${TTP_ACCOUNTING_URL}/collaborator-space?without_header`;
              break;
            case "POWERTEAM":
              icon = `https://s3.tamtam.pro/v2/apps/powerteam.png`;
              url = `${TTP_POWERTEAM_URL}/collaborator-space?without_header`;
              break;
          }
          return (
            <li key={`drawer-${index}`}>
              <Drawer
                icon={<img src={icon} alt="" />}
                label={item.toLowerCase()}
                src={url}
                isActive={`app-${index}` === openDrawer}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    return (
      <div className={styles.drawers_trigger_box}>
        <div className={styles.drawers_trigger}>
          {this.renderDrawers()} {this.renderApps()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/DrawersList/DrawersListComponent.js